<template>
  <div
    :class="[$attrs.class, 'v-selection-control-group']"
    :style="$attrs.style"
  >
    <v-radio-group
      v-bind="$attrs"
      :model-value="modelValue"
      @update:modelValue="val => emit('update:modelValue', val)"
    >
      <slot />
    </v-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';

const attrs = useAttrs();
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
});
const emit = defineEmits(['update:modelValue']);
</script>

<style lang="scss" scoped>
.v-selection-control-group {
  & > .v-text-field--outlined > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-secondary));
  }
  &
    > .v-text-field--outlined.v-input--is-focused
    > .v-input__control
    > .v-field__input,
  &
    > .v-text-field--outlined.v-input--is-dirty
    > .v-input__control
    > .v-field__input {
    background-color: rgb(var(--v-theme-white));
  }
}
</style>
